import { render, staticRenderFns } from "./FaqAnswer.vue?vue&type=template&id=12e46a66"
import script from "./FaqAnswer.vue?vue&type=script&lang=js"
export * from "./FaqAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports